<template>
	<div>
		<v-progress-linear
			v-if="loadingItems"
			indeterminate
			color="primary"
			class="mb-2"
		></v-progress-linear>
		<v-simple-table 
			v-else
			class="rounded-lg simple-table elevation-1" dense
			:class="!$slots['action-bar'] ? 'simple-table--round-top' : ''"
			:loading="loadingItems">
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left" v-for="(header, index) in headers" :key="index">
							{{ header.text }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in items" :key="item.id">
						<td v-for="(header, index) in headers" :key="index">
							<template v-if="header.type && header.type == 'html'">
								<p> 
									<span v-html="item[header.value]"></span>
									<span v-if="item[header.value]=='' && invoiceRegenerable && item[regenerateInvoiceButton.visibility]">
										<v-btn @click="clickColActionBtn(regenerateInvoiceButton.action, item, tableRefName)" 
											color="primary" 
											icon 
											:loading="(item.loading && item.loading[regenerateInvoiceButton.action]) || false"
											v-if="!regenerateInvoiceButton.visibility || item[regenerateInvoiceButton.visibility]">
											<v-icon>{{ regenerateInvoiceButton.icon }}</v-icon>
										</v-btn>
									</span>
									<span v-if="hasInvoiceListPdfs(item) && item[header.value]">
										<v-btn @click="clickColInvoicesListBtn(item)"
											color="primary" icon
											:loading="item.loading || false">
											<v-icon>mdi-eye-plus-outline</v-icon>
										</v-btn>
									</span>
								</p>
							</template>
							<template v-else-if="header.value=='total_extra_users'">
								<div class="d-flex align-items-center">
									<p class="text-nowrap m-0">{{ item[header.value] }}</p>
									<v-tooltip top v-if="!item.client_service_delivery">
										<template v-slot:activator="{ on, attrs }">
											<v-btn @click="clickAddPaidUsers(item)"
											color="primary" icon v-bind="attrs" v-on="on"
											v-if="!item.is_finished && item.is_latest"
											:loading="(item.loading && item.loading[actionBtn.action]) || false">
											<v-icon>mdi-account-multiple-plus-outline</v-icon>
										</v-btn>
										</template>
									<span>Añadir usuarios</span>
									</v-tooltip>
								</div>
							</template>
							<template v-else-if="header.value=='users_count'">
								<div class="d-flex align-items-center">
									<p class="text-nowrap m-0">{{ item[header.value] }}</p>
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-btn @click="clickAddPaidUsers(item)"
											color="primary" icon v-bind="attrs" v-on="on"
											v-if="!item.is_finished && item.is_latest"
											:loading="(item.loading && item.loading[actionBtn.action]) || false">
											<v-icon>mdi-account-multiple-plus-outline</v-icon>
										</v-btn>
										</template>
									<span>Añadir usuarios</span>
									</v-tooltip>
								</div>
							</template>
							<!-- Columna "actions" con los botones de acciones-->
							<template v-else-if="header.value == 'actions'">
								<v-tooltip top v-for="actionBtn in actionBtnList" :key="actionBtn.action">
									<template v-slot:activator="{ on, attrs }"v-if="isActionVisible(actionBtn, item)">
										<v-btn v-if="actionBtn.is_svg" @click="clickColActionBtn(actionBtn.action, item, tableRefName)"
											icon v-bind="attrs" v-on="on">
											<img v-if="actionBtn.is_svg" :src="require(`@/assets/${actionBtn.icon}`)"
												@click="clickColActionBtn(actionBtn.action, item, tableRefName)" />
										</v-btn>
										<v-btn v-else @click="clickColActionBtn(actionBtn.action, item, tableRefName)" color="primary"
											icon v-bind="attrs" v-on="on">
											<v-icon>{{ actionBtn.icon }}</v-icon>
										</v-btn>
									</template>
									<span>{{ actionBtn.name }}</span>
								</v-tooltip>
							</template>
							<template v-else-if="header.type && header.type == 'link' && header.link_text">
								<span v-if="item[header.value]">
									<a :href="item[header.value]">{{ header.link_text }}</a>
									<v-btn v-if="hasInvoiceListPdfs(item) && item[header.value]" 
											@click="clickColInvoicesListBtn(item)" 
											color="primary" 
											icon
											:loading="item.loading || false">
										<v-icon>mdi-eye-plus-outline</v-icon>
									</v-btn>
								</span>
								<!-- <v-tooltip v-else-if="header.table && header.table == 'additional_services'" right>
									sdf
									<template v-slot:activator="{ on, attrs }" v-if="item.refund_percentage != 1">
										<v-btn @click="clickUploadPaymentFileBtn(item)" color="primary" icon
										:disabled="loadingItems" v-bind="attrs" v-on="on">
											<v-icon>mdi-file-upload-outline</v-icon>
										</v-btn>
									</template>
									<span>Adjuntar archivo</span>
								</v-tooltip> -->
								<p v-else>
									<span v-if="(item[header.value] == null || item[header.value]=='') && invoiceRegenerable && item[regenerateInvoiceButton.visibility]">
										<v-btn @click="clickColActionBtn(regenerateInvoiceButton.action, item, tableRefName)" 
											color="primary" 
											icon 
											:loading="(item.loading && item.loading[regenerateInvoiceButton.action]) || false">
											<v-icon>{{ regenerateInvoiceButton.icon }}</v-icon>
										</v-btn>
									</span>
								</p>
							</template>
							<template v-else-if="header.type && header.type == 'blob_link' && header.link_text">
								<p v-if="item[header.value]"><a @click="clicked_link(item)">{{ header.link_text }}</a></p>
								<v-btn v-if="hasInvoiceListPdfs(item) && item[header.value]" @click="clickColInvoicesListBtn(item)" 
									color="primary" icon
									:loading="item.loading || false">
									<v-icon>mdi-eye-plus-outline</v-icon>
								</v-btn>
							</template>
							<template v-else-if="header.type && header.type == 'nested_property'">
								<span>
									{{ getSplitedItem(item, header.value) }}
								</span>
							</template>
							<template v-else-if="header.type && header.type == 'nested_property_link'"> 
								<a :href="getSplitedItem(item, header.value)" v-if="getSplitedItem(item, header.value)">
									{{ header.link_text }}
								</a>
								<span v-else>
									<v-btn @click="clickColActionBtn(regenerateInvoiceButton.action, item, tableRefName)" 
										color="primary" 
										icon 
										:loading="(item.loading && item.loading[regenerateInvoiceButton.action]) || false"
										v-if="invoiceRegenerable && item[regenerateInvoiceButton.visibility]">
										<v-icon>{{ regenerateInvoiceButton.icon }}</v-icon>
									</v-btn>
								</span>
							</template>
							<template v-else-if="header.type && header.type == 'nested_property_link'">
								<a :href="getSplitedItem(item, header.value)">
									{{ header.link_text }}
								</a>
							</template>
							<template v-else>
								<v-tooltip v-if="header.table && header.table === 'additional_services' && header.value === 'invoice_concept' && item.invoice_lines && item.invoice_lines.length > 1" right >
									<template v-slot:activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">{{ item[header.value] }}</span>
									</template>
									<div>
										<span v-for="(line, index) in item.invoice_lines" :key="index">{{ line.concept }} ( {{ line.quantity }} )<br></span>
									</div>
								</v-tooltip>
								<!-- Si el header tiene show_button_when_empty y el valor está vacío, mostrar botón -->
								<span v-else-if="header.show_button_when_empty && !item[header.value]">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												v-if="header.is_svg"
												@click="clickSelectCompaniesBtn(item)"
												icon
												v-bind="attrs"
												v-on="on">
												<img :src="require(`@/assets/${header.button_icon}`)" />
											</v-btn>
											<v-btn
												v-else
												@click="clickSelectCompaniesBtn(item)"
												color="primary"
												icon
												v-bind="attrs"
												v-on="on">
												<v-icon>{{ header.button_icon }}</v-icon>
											</v-btn>
										</template>
										<span>{{ header.button_text }}</span>
									</v-tooltip>
								</span>
								<span v-else-if="header.value == 'pay_charge'">
									<v-tooltip 
										v-if="item && !item.invoice_pdf_url"
										top
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												@click="openPayChargePopup(item)"
												color="primary"
												icon
												v-bind="attrs"
												v-on="on">
												<v-icon>{{ header.button_icon }}</v-icon>
											</v-btn>
										</template>
										<span>{{ header.button_text }}</span>
									</v-tooltip>
								</span>
								<span v-else>{{ item[header.value] }}</span>
							</template>
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
	</div>
</template>

<script>
import { client } from "@/api/client"


export default {

	name: 'AppSimpleTableWithApi2',
	props: {
		headers: {
			type: Array,
			default: [],
		},
		url: {
			type: String,
			required: true
		},
		tableRefName: {
			type: String,
			required: true
		},
		actionBtnList: {
			type: Array,
			default() {
				return [];
			}
		},
		invoiceRegenerable: {
			type: Boolean,
			default: false
		},
		regenerateInvoiceButton: {
			type: Object,
			default() {
					return {'name': 'Regenerar Factura', 'action': 'regenerate_invoice', 'icon': 'mdi-refresh', 'visibility': 'is_invoice_generable' };
			}
		},
		api_params: {
			type: Object,
			default: undefined,
		},
		additionalServices: {
			type: Object,
			required: false,
			default: () => ({}),
		},
	},
	data() {
		return {
			items: [],
			loadingItems: false,
		}
	},
	methods: {
		getItems() {
			return new Promise((resolve, reject) => {
				this.loadingItems = true;
				let params = {};
				for (let key in this.api_params) {
					params[key] = this.api_params[key];
				}
				client.get(this.url, { params: params }).then(response => {
					this.items = response.data.results;
					this.$emit('has-items', this.items.length > 0);
					this.$emit('get-items', this.items);
					resolve()
				}).catch(error => {
					this.$emit('has-items', false);
					reject(error);
				}).finally(() => {
					this.loadingItems = false;
				});
			});
		},
		clickColActionBtn(action, item, tableRef) {
            this.$emit('click-col-action-btn', action, item, tableRef);
		},
        clickColInvoicesListBtn(item) {
            this.$emit('click-col-invoice-list-btn', item);
        },
		async clicked_link(item) {
			let s_url = item['path']
			const response = await fetch(s_url)
			const blob = await response.blob();
			const url = await URL.createObjectURL(blob)
			const a = document.createElement("a");
			a.href = url;
			let ext = 'eml'
			a.download = 'correo.' + ext;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);

		},
		getSplitedItem(item, header) {
			// [campo 1, campo 2] ...
			const parts = header.split('.');
			let current = item;
			for (const part of parts) {
				if (current[part] === undefined) {
					return undefined; // Return undefined if the path does not exist
				}
				current = current[part];
			}
			return current;
		},
		clickUploadPaymentFileBtn(item) {
			this.$emit('click-upload-payment-file-btn', item);
		},
        clickAddPaidUsers (item) {
            this.$emit('click-col-add-paid-users', item);
        },
		clickSelectCompaniesBtn(item) {
			console.log('clickSelectCompaniesBtn called with item:', item);
			this.$emit('click-col-select-companies', item);
		},
		openPayChargePopup(item) {
			this.$emit('open-pay-charge-popup', item);
		},
		isActionVisible(actionBtn, item) {
			function getNestedValue(obj, path) {
				return path.split('.').reduce((acc, key) => acc && acc[key], obj);
			}
			const visibility = actionBtn.visibility;
			if (!visibility) return true;

			if (Array.isArray(visibility)) {
				return visibility.every(path => Boolean(getNestedValue(item, path)));
			}
			return Boolean(getNestedValue(item, visibility));
		},
		hasInvoiceListPdfs(item) {
			return Array.isArray(item.invoices_list_pdfs) && item.invoices_list_pdfs.length > 0
		}
	},
	mounted() {
		this.getItems();
	},
}
</script>

<style scoped>
.simple-table {
	background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white) !important;
}

::v-deep.simple-table thead>tr:not(.simple-table__action-bar)>th {
	background-color: var(--v-primaryLight-base) !important;
	border-radius: 0 !important;
	color: var(--v-primary-base) !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:first-of-type {
	border-radius: 0.5rem 0 0 0 !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:last-of-type {
	border-radius: 0 0.5rem 0 0 !important;
}

::v-deep.simple-table tbody>tr>td {
	background-color: #FFF !important;
}

::v-deep.simple-table tbody>tr>td:not(:last-of-type) {
	border-right: 1px solid var(--v-primary-base);
}
.align-items-center{
    align-items: center
}
.text-nowrap{
    white-space: nowrap;
    overflow: hidden;
}
.m-0{ margin: 0 !important;}
</style>